export enum TelemetryRuleIgnoreMode {
    Always = "Always",
    Never = "Never",
    DiagnosticsDisabled = "DiagnosticsDisabled",
    SuccessOnly = "SuccessOnly",
}
